import SVG from './SVG'

export const ArrowLeft = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/sv
      g"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="arrow_left_24">
        <path
          fillRule="evenodd"
          d="M15.707 5.293a1 1 0 010 1.414L10.414 12l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z"
          className="Vector (Stroke)"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
